import { core } from '../core/index.js';
import { filterFabricErrors } from '../errors/errors.js';
import { type FabricError } from '../fabric-error/index.js';

export type FabricPreviewImageUrlItem = {
  /**
   * 唯一标识, 可选, 可能增加click点击事件的时候需要回传.
   */
  id?: string;
  /**
   * Http网络图片地址, 或者本地图片地址.
   */
  url: string;
  /**
   * 当前图片的描述信息
   */
  desc?: string;
};

export type WatermarkInfo = {
  /**
   * 水平间距
   * @default 80
   */
  horizontalSpace?: number;
  /**
   * 垂直间距
   * @default 100
   */
  verticalSpace?: number;
  /**
   * 水印文字大小
   * @default 17
   */
  fontSize?: number;
  /**
   * 水印文字颜色
   * @default `#FFFFFFFF`
   */
  textColor?: string;
  /**
   * 水印文字
   * @default ''
   */
  text?: string;
};

/**
 * 在新页面中全屏预览图片。
 */
export type FabricPreviewImageOptions = {
  /**
   * 需要预览的图片链接列表。可以是本地链接, 也可以是网络地址
   */
  urls: FabricPreviewImageUrlItem[];
  /**
   * 描述信息显示的总行数
   */
  lines: number;
  /**
   * 当前显示图片的链接位置索引值, 默认:urls 的第一张
   * @default 0
   */
  current?: number;
  /**
   * 水印信息
   */
  watermark?: WatermarkInfo;
};

export type FabricPhotoPreviewImageFileApi = (
  options: FabricPreviewImageOptions,
  callback?: (err: FabricError | null, id?: string) => void
) => void;

/**
 * 关闭图片预览器
 */
export type FabricClosePhotoPreviewImageFileApi = () => void;

/**
 * 在新页面中全屏预览图片。
 */
export const previewImage: FabricPhotoPreviewImageFileApi = (
  options: FabricPreviewImageOptions,
  callback?: (err: FabricError | null, id?: string) => void
): void => {
  core.call<'fabric_photo.previewImage', FabricPreviewImageOptions, string>(
    'fabric_photo.previewImage',
    {
      ...options,
      current: options.current ?? 0,
    },
    callback
      ? (result) => {
          const fabricErrors = filterFabricErrors(
            result.code,
            result.message,
            result.data
          );
          // 如果code==='1', 约定当前为清理上一次的callback函数使用, 不做业务回调处理.
          if (fabricErrors?.code === '1') {
            return;
          }
          callback(fabricErrors || null, result.data);
        }
      : undefined
  );
};

/**
 * 关闭当前打开的图片预览器
 */
export const closePreviewImage: FabricClosePhotoPreviewImageFileApi = () => {
  core.call<'fabric_photo.closePreviewImage'>('fabric_photo.closePreviewImage');
};
